"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonReFresh = /** @class */ (function (_super) {
    __extends(ButtonReFresh, _super);
    function ButtonReFresh(props) {
        return _super.call(this, props) || this;
    }
    ButtonReFresh.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonReFresh.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { icon: "reload", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this) })));
    };
    return ButtonReFresh;
}(React.Component));
exports.default = ButtonReFresh;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonReFresh.tsx
// module id = 1752
// module chunks = 0